<template>
  <router-link :to="to"><slot /></router-link>
</template>

<script>
export default {
  props: {
    to: String,
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #ffffff;
  font-size: 0.4rem;
  margin-left: 0.1rem;
  span {
    margin-left: 0.1rem;
    font-size: 0.4rem;
  }
}
</style>
